module.exports = __webpack_public_path__ + "static/media/search_icon.d2b76cef.svg";